import { axiosV4 } from "../../../Utils/Axios/axiosV4";

export const getSampleCategoriesService = async (
  userToken: string,
  lessonId: string | number
) => {
  return axiosV4.get(`/user/sample-exams/categories?sample_exam_lesson_id=${lessonId}`, {
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
  });
};
